import { useState } from "react";
import { adminApi } from "@/lib/adminApi";

export const INQUIRY_STATUSES = ["new", "contacted", "won"];

export const INQUIRY_STATUS_STYLES = {
  new: "bg-royal-light text-royal border-royal/30",
  contacted: "bg-amber-50 text-amber-700 border-amber-200",
  won: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

/** Status tag + inline selector for one consultation inquiry. */
export function InquiryStatus({ inquiry, onChanged }) {
  const [busy, setBusy] = useState(false);
  const status = inquiry.status || "new";

  const change = async (e) => {
    const next = e.target.value;
    if (next === status) return;
    setBusy(true);
    try {
      await adminApi.patch(`/admin/inquiries/${inquiry.id}`, { status: next });
      await onChanged();
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className="inline-flex items-center">
      <span className="sr-only">Inquiry status</span>
      <select
        value={status}
        onChange={change}
        disabled={busy}
        data-testid={`admin-inquiry-status-${inquiry.id}`}
        className={`cursor-pointer rounded border px-2 py-1 font-mono-sub text-[11px] font-semibold uppercase tracking-wider focus:outline-none focus-visible:ring-2 focus-visible:ring-royal disabled:opacity-50 ${INQUIRY_STATUS_STYLES[status]}`}
      >
        {INQUIRY_STATUSES.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
    </label>
  );
}
